export default {
      id: "reply-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#reply-usage",
      toString: function () {
        return this.url;
      }
    }